import { Component } from '@angular/core';
import { Routes } from '@angular/router';

import { BaMenuService } from '../theme';
import { LoginService } from './login/login.service';

@Component({
  selector: 'pages',
  template: `
    <style>
    .auth-main {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      height: 100%;
      width: 92%;
      position: absolute;
    }
    .auth-block {
      width: 100%;
      border-radius: 5px;
      background: rgba(0, 0, 0, 0.55);
      color: #fff;
      padding: 32px;
      height: 80%;
  }
  .al-footer-left{
    padding-left: 0px;
  }
  </style>
    <ba-page-top-custom></ba-page-top-custom>
    <div class="al-main" style="margin-left: 0px;">
      <div class="al-content">
        <div style="width: 100%;margin: 0 auto;">
          <div class="auth-block" style="padding-bottom: 29%">
            <h1>Welcome to the SpaceAge labs</h1>
            <h1>Prototype, Connect and manage your IOT products with our platform.</h1>
          </div>
        </div>
      </div>
    </div>
    <footer class="al-footer clearfix">
      <div class="al-footer-left" translate>Prototype, Connect and manage your IOT products with our platform.
      </div>
    </footer>
    <ba-back-top position="200"></ba-back-top>
    `
})
export class Pages {

  constructor(private _menuService: BaMenuService,private _loginService: LoginService) {
  }

  ngOnInit() {
    this._menuService.updateMenuByRoutes(<Routes>this._loginService.getPagesMenu());
  }
  onClickMe() {
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/pages.component.ts